import { createParamDecorator, ExecutionContext } from '@nestjs/common';

import { User } from '../types';

export const CurrentUser = createParamDecorator((data: keyof User, context: ExecutionContext) => {
  const { user } = context.switchToHttp().getRequest();
  return data ? user?.[data] : user;
});
